import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import MembershipCustomTextContent from '../../component/MembershipCustomTextContent/MembershipCustomTextContent'
import { Helmet } from 'react-helmet'


const cardList = [
  {
    img:"/images/creatives/service-main-9.webp",
    name:"Naturopathic Medicine",
    rank:"",
    link:"/naturopathic-medicine",
    para:'An integrative approach combining clinical science and natural therapies to optimize health.'
  },
  {
    img:"/images/creatives/service-main-4.webp",
    name:"Global Medical Consulting",
    rank:"",
    link:"/global-medical-consulting",
    para:'Access top international experts for rare or complex conditions.'
  },
]

const listData = [
     {
        img:"/images/creatives/dna-testing-text-1.png",
        title:"Why it matters",
        para:"DNA doesn’t just define your traits—it can empower smarter healthcare decisions. Understand your body at its most fundamental level."
    },
     {
        img:"/images/creatives/dna-testing-text-1.png",
        title:"Who it’s for",
        para:"Ideal for clients focused on preventative care, bio-optimization, or managing complex health conditions."
    },
     {
        img:"/images/creatives/dna-testing-text-1.png",
        title:"How it works",
        para:"A simple saliva or blood sample is collected and sent to a partner lab. Results are reviewed by our medical team and integrated into your care plan."
    },
]

const BoostCardContent = [
    "Identify predispositions to chronic conditions",
    "Optimize nutrition, fitness, and supplement plans",
    "Tailor medication choices to genetic compatibility",
    "Enable earlier and more accurate health interventions"
]


function DnaTesting() {
  return (
     <div style={{backgroundColor:"#FEFCF0"}}>
      <Helmet>
        <title>
        Genetic & DNA Clinical Testing Services in Toronto
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/dna-clinical-testing"
        />
        <meta
          name="description"
          content="Gain personalized insights into your genes, health, and wellness. Optimize your care with precision DNA Clinical testing services at The Toronto Clinic."
        ></meta>
        
      </Helmet>
         <Header/>
        <HomeHero
            heading='DNA Clinical Testing'
            // content='Genetic testing that reveals how your DNA influences disease risk, drug metabolism, nutrient processing, and long-term health planning.'
            content='Unlock personalized insights into your health through precision DNA analysis.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
             btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/dnaTesthero-image.png"}
            bgImage={"/images/creatives/boost-shoot-bg.png"}
            btnCalnedly={true}
            calendlyType={8}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="A personalized approach"
            para="Our DNA Clinical Testing reveals how your genetic makeup influences your health risks, nutrient metabolism, and response to medications. By interpreting this data, our physicians can design a prevention-first care plan tailored to your biology. Ideal for individuals seeking longevity, performance, and disease risk reduction."
            bgImg="/images/creatives/service-main-3.webp"
          />

          <MembershipCustomTextContent
            listData={listData}
            shiftRow={true}
            nonSwitchingImg={true}
          />
        </div>

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>

        <BoostCard
          cardContentProp={BoostCardContent}
        />

        
        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph="Explore related services that deepen your results or support your next step in care."
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
        </div>
    </div>
  )
}

export default DnaTesting